import { spawn } from 'redux-saga/effects';
import { adminsSaga } from 'redux/reducers/admins/saga';
import { authSaga } from 'redux/reducers/auth/saga';
import { channelsSaga } from 'redux/reducers/channels/saga';
import { reportsSaga } from 'redux/reducers/reports/saga';
import { transactionSaga } from 'redux/reducers/transaction/saga';
import { usersSaga } from 'redux/reducers/users/saga';
import { advertisingSaga } from './reducers/advertising/saga';
import { aiChatBotsSaga } from './reducers/ai-chat-bot/saga';
import { aiPromptUsersSaga } from './reducers/ai-prompts/saga';
import { aiServicesSaga } from './reducers/ai-services/saga';
import { apkFilesSaga } from './reducers/apk-files/saga';
import { dashboardSaga } from './reducers/dashboard/dashboard-saga';
import { downloadSaga } from './reducers/download/saga';
import { financeSaga } from './reducers/finance/finance-saga';
import { moderationSaga } from './reducers/moderation/saga';
import { mailerSaga } from './reducers/mailer/saga';
import { reactionsSaga } from './reducers/reactions/saga';
import { referralSaga } from './reducers/referral/saga';
import { reservedUsernamesSaga } from './reducers/reserved/saga';
import { supportSaga } from './reducers/support/saga';
import { utilsSaga } from './reducers/utils/saga';

export default function* rootSagas() {
  yield spawn(authSaga);
  yield spawn(channelsSaga);
  yield spawn(usersSaga);
  yield spawn(transactionSaga);
  yield spawn(reportsSaga);
  yield spawn(adminsSaga);
  yield spawn(supportSaga);
  yield spawn(aiServicesSaga);
  yield spawn(reservedUsernamesSaga);
  yield spawn(utilsSaga);
  yield spawn(downloadSaga);
  yield spawn(financeSaga);
  yield spawn(referralSaga);
  yield spawn(apkFilesSaga);
  yield spawn(aiChatBotsSaga);
  yield spawn(reactionsSaga);
  yield spawn(dashboardSaga);
  yield spawn(aiPromptUsersSaga);
  yield spawn(moderationSaga);
  yield spawn(mailerSaga);
  yield spawn(advertisingSaga);
}
